import React, { useState, useEffect } from "react";
import { Select, SelectVariant } from "@patternfly/react-core";

const MultiTypeaheadSelectInput = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(
    props.selected ? props.selected : []
  );

  const onToggle = (isOpen) => {
    setIsOpen(isOpen);
  };

  const onSelect = (event, selection) => {
    event.preventDefault();
    const prevSelected = [...selected];
    if (prevSelected.includes(selection)) {
      setSelected(prevSelected.filter((item) => item !== selection));
    } else {
      setSelected([...prevSelected, selection]);
    }
  };

  const clearSelection = () => {
    setSelected([]);
    setIsOpen(false);
  };

  useEffect(() => {
    props.onSelect && props.onSelect(selected);
  }, [selected]);

  const customFilter = (e) => {
    let typeaheadFilteredChildren = props.options;
    if (e && e.target) {
      let input;
      try {
        input = new RegExp(e.target.value.toString(), "i");
      } catch (err) {
        input = new RegExp(
          e.target.value.toString().replace(/[.*+?^${}()|[\]\\]/g, "$&"),
          "i"
        );
      }
      if (e.target.value.toString() !== "") {
        typeaheadFilteredChildren = props.options.filter((option) =>
          input.test(option.props.value.toString())
        );
      }
    }
    return typeaheadFilteredChildren;
  };

  return (
    <div>
      <span id={props.titleId} hidden>
        {props.placeholder}
      </span>
      <Select
        variant={SelectVariant.typeaheadMulti}
        aria-label={props.placeholder}
        onToggle={onToggle}
        onSelect={onSelect}
        onClear={clearSelection}
        onFilter={customFilter}
        selections={selected}
        isOpen={isOpen}
        aria-labelledby={props.titleId}
        placeholderText={props.placeholder}
      >
        {props.options}
      </Select>
    </div>
  );
};

export default MultiTypeaheadSelectInput;
